module.exports = __webpack_public_path__ + "static/img/publicity-icon4.3a9c768.png";


//////////////////
// WEBPACK FOOTER
// ./static/publicity-icon4.png
// module id = nr9X
// module chunks = 1